import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CoOwnerState {
  firstName: string;
  lastName: string;
  middleName: string;
  phoneNumber: string;
  dateOfBirth: string;
  email: string;
  last4SSN: string;
  address: string;
  city: string;
  state: string;
  zip: string;
}

const initialState: CoOwnerState = {
  firstName: '',
  lastName: '',
  middleName: '',
  phoneNumber: '',
  dateOfBirth: '',
  email: '',
  last4SSN: '',
  address: '',
  city: '',
  state: '',
  zip: '',
};

const coOwnerInfo = createSlice({
  name: 'coOwnerInfo',
  initialState: initialState,
  reducers: {
    setCoOwner: (state: CoOwnerState, { payload }: PayloadAction<Partial<CoOwnerState>>) => {
      Object.assign(state, payload);
    },
  },
});

export const { setCoOwner } = coOwnerInfo.actions;

export default coOwnerInfo.reducer;
